<!--
  @Description: 会议议程
  @Author: wang.y 
  @Date: 2026-09-08 
-->
<template>
  <div class="main-container">
    <page-header>{{
      actExhibitionDto.name | dealLanguage(actExhibitionDto.enActivityName)
    }}</page-header>
    <div class="content">
      <img
        :src="actExhibitionDto.logoPath | logo_show"
        v-if="language === 'zh'"
      />
      <img :src="actExhibitionDto.shareImagePath | logo_show" v-else />
    </div>
  </div>
</template>
<script>
import { getActExhibitionDetailInfo } from '@/service/vbef'
import PageHeader from '@/components/mobile/pageHeader.vue'
import { mapState } from 'vuex'
export default {
  components: {
    PageHeader,
  },
  created() {
    this.getDetail()
  },
  mounted() {},
  data() {
    return {
      actExhibitionDto: {},
      loading: false,
    }
  },
  computed: {
    ...mapState({
      language: (state) => state.language,
    }),
  },
  methods: {
    async getDetail() {
      this.loading = true
      let res = await getActExhibitionDetailInfo({
        actId: this.$route.params.id,
      })
      this.loading = false
      if (res.code == 0) {
        this.$set(
          this.$data,
          'actExhibitionDto',
          res.data.actExhibitionDto || {},
        )
      } else {
        this.$Messager.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
  },
}
</script>
<style lang="stylus" scoped>
@import '~styles/common-m.styl'
.content
  padding .4rem
  font-size: 0
  display flex
  align-items center
  justify-content center
  img
    max-width: 100%
    height auto
</style>
